import React from 'react';
import { Descriptions, Tag } from 'antd';
import {
  EditOutlined,
} from '@ant-design/icons';
import '@/publicCss/style.css';
import './index.css';
import { MAX_PIN_TEXI_LIMIT } from '../../services/helper/portCanvasHelper';

const DescItem = Descriptions.Item;
const SELECTED = 'Selected', AVAILABLE = 'Available';

const descDom = (props) => {
  const { descData, show, selectTags, maxPinLen, openImportPanel, maxTag, addMaxTag } = props;
  const width = maxPinLen * 7.5 + 14
  return <div className='margin-top-20 port-setup-desc-gorup'>
    {descData.map(item => {
      const descItem = [{ label: SELECTED, list: item.used.sort() }, { label: AVAILABLE, list: item.unused.sort() }, { label: <span>Import <EditOutlined className='port-setup-import-icon' onClick={() => openImportPanel(item)} /></span>, list: (item.import || []).sort() }]
      const color = item.netType === 'PowerNet' ? 'volcano' : 'geekblue'
      return <div className={`port-setup-border port-setup-desc port-border-${item.netType}`} key={item.title}>
        <span className="font-bold port-setup-title-color">{item.title}</span>
        <Descriptions layout="vertical" column={1} size="small" className="desc-body" bordered>
          {descItem.map(d => {
            const maxNumber = maxTag[`${item.netType}-${d.label}`] || MAX_PIN_TEXI_LIMIT;
            const overLimit = d.list.length > maxNumber;
            const showList = overLimit ? d.list.slice(0, maxNumber) : d.list;
            return <DescItem label={d.label} key={d.label}>
              {showList.map(pin => {
                return <Tag
                  color={show.includes(pin) ? 'magenta' : color}
                  className="port-setup-tag"
                  onClick={() => selectTags([pin], item.netType)}
                  style={{ width }}
                  key={pin}
                >{pin}</Tag>
              })}
              {overLimit && <div className='port-setup-show-more-tag' onClick={() => addMaxTag(`${item.netType}-${d.label}`, maxNumber + MAX_PIN_TEXI_LIMIT)}>+{d.list.length - maxNumber}, show more pin tags...</div>}
            </DescItem>
          })}
        </Descriptions>
      </div>
    })}
  </div>
}

export default descDom